export const color = {
    primary: "#1890ff",
    onPrimary: "#1890ff",
    primaryContainer: "#002140",

    secondary: "#00BDCB",
    onSecondary: "#E6F8FA",
    secondaryContainer: "#CCF2F5",

    error: "#BA1A1A",
    onError: "#F8E8E8",
    errorContainer: "#F1D1D1",

    background: "#F2F2F2",
    onBackground: "#1A1A1A",

    textColor: "#fff",

    mandatoryColor: "#FF0000"

}





